/* RESPONSIBLE TEAM: team-proactive-support */
import Fragment from 'ember-data-model-fragments/fragment';
import { attr } from '@ember-data/model';

export default class StateChange extends Fragment {
  @attr('number') declare adminId: number;
  @attr('number') declare reason: number;
}
